import styled from 'styled-components'

export const Row = styled.tr<{selected?: boolean}>`
  &&& {
    padding: ${props => (props.selected ? '0' : '0 1rem')};
    border-bottom: ${props => !props.selected && 'none'};
    border-top: ${props =>
      props.selected && '0.5px solid rgba(108, 108, 108, 1)'};
  }
`
